// import React from "react";

import withTrekPermission from '../../../../HOCs/withTrekPermission';
import { openNestedOverviewModal } from '../../../../redux/actions/trekOverviewActions';

const EditHandler = ({ editAction, children, dispatch, ...rest }) => {
  const {
    // isLoggedIn,
    // isTemplate,
    // isPublic,
    // isDraft,
    // isFollower
    isOwner,
  } = rest;

  if (isOwner) {
    return children({ handleEdit: editAction });
  } else {
    return children({
      handleEdit: () =>
        dispatch(openNestedOverviewModal({ component: 'OnlyOwnerCanEdit' })),
    });
  }

  //   if (isFollower) return children({ handleEdit: () => rest.dispatch(action()) });
  // to one nested modals in trekOverview showning messages and CTAs;
  //   return children({
  //     handleEdit: () => console.log("need new permission case", rest)
  //   });
};

export default withTrekPermission(EditHandler);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/Preferences/EditHandler.jsx